import { AbstractPlugin, MediaPlayerEvents } from 'mlb-media-player';
import { first } from 'rxjs/operators';
import _find from 'lodash/find';
import _get from 'lodash/get';
class ChartBeatPlugin extends AbstractPlugin {

    constructor(config, observationCenter) {

        super(config, observationCenter);


        /**
         *
         * @type {observer}
         * @desc The player observer
         *
         */
        this.playerSubject = observationCenter.playerSubject;

        /**
         *
         * @type {object}
         * @desc ChartBeat library object
         *
         */
        this.cbv = undefined;

        /**
         *
         * @type {domElement}
         * @desc Reference to the video tag dom element
         *
         */
        this.domPlayer = undefined;

        /**
         *
         * @type {object}
         * @desc The metadata object
         *
         */
        this.metaData = undefined;
        this.initPlugin();

    }

    /**
     * @desc Init the charBeat Plugin
     *
     * @memberof ChartBeatPlugin
     */
    initPlugin() {

        try {

            this.checkChartBeatReady();

        } catch(e) {

            console.error(e);

        }

    }

    /**
     *
     *
     * @desc Check chartBeat Library readiness
     * @memberof ChartBeatPlugin
     */
    checkChartBeatReady() {

        if (document.readyState === "complete" && !window._cbv) {

            throw new Error('ChartBeat library not found. Can not track the player');

        }

        if (document.readyState !== "complete" && !window._cbv) {

            const initPluginBound = this.initPlugin.bind(this);
            window.addEventListener("load", () => {

                initPluginBound();

            });
            return;

        }

        this.cbv = window._cbv;
        this.playerSubscription();

    }

    /**
     * @desc Handel player subscription fo start tracking the video element
     *
     * @memberof ChartBeatPlugin
     */
    playerSubscription() {

        const HTML5PlayerEvents = MediaPlayerEvents.HTML5;

        this.playerSubject
            .pipe(
                first(
                    ({ type }) => type === HTML5PlayerEvents.MEDIA_START
                ))
            .subscribe(() => {

                this.setVideoTagReference();
                this.updateVideoDom(this.domPlayer, this.metaData);
                this.cbv.push(this.domPlayer);
                // console.log('tracking player');

            });

    }

    /**
     *
     * @desc Finds the src URL for the specified aspect ratio, width and height in metaData.image.cuts
     * @param {object} metaData The current metaData object to search
     * @param {string} aspectRatio Default "16:9" the aspect ratio to match in image.cuts
     * @param {number} width Default 960 the width to match in image.cuts
     * @param {number} height Default 540 the height to match in image.cuts
     *
     */
    getPosterImage(metaData, aspectRatio = '16:9', width = 960, height = 540) {

        const imageCuts = _get(metaData, 'image.cuts', []);
        const result = _find(imageCuts, {
            aspectRatio,
            width,
            height,
        });
        return _get(result, 'src', '');

    }

    /**
    *
    * @desc Set metadata in the plugin instance
    *
    */
    setMetadata(metaData) {

        this.metaData = {
            titleValue: metaData.title,
            posterValue: this.getPosterImage(metaData),
        };

        if (this.domPlayer) {

            this.updateVideoDom(this.domPlayer, this.metaData);

        }

    }

    /**
     * @desc Set a reference to the video dom element
     *
     * @memberof ChartBeatPlugin
     */
    setVideoTagReference() {

        if (!this.mediaPlayer.player.videoEl) {

            throw new Error('Video Tag element not defined in media player');

        }

        this.domPlayer = this.mediaPlayer.player.videoEl;

    }

    /**
     * @desc Update metadata on video tag element
     *
     * @param {domReference} domPlayer
     * @param {object} metaData
     * @memberof ChartBeatPlugin
     */
    updateVideoDom(domPlayer, metaData) {

        const titleValue = _get(metaData, 'titleValue');
        const posterValue = _get(metaData, 'posterValue');

        if (titleValue) {

            domPlayer.setAttribute('title', titleValue);

        }

        if (posterValue) {

            domPlayer.setAttribute('poster', posterValue);

        }

    }

}

export default ChartBeatPlugin;
